module.exports = __webpack_public_path__ + "static/img/6.afa1e18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/6.png
// module id = q+QX
// module chunks = 0